import dayjs from "dayjs";
import PropTypes from "prop-types";
import { FormProvider, useForm } from "react-hook-form";

import { yupResolver } from "@hookform/resolvers/yup";
import { Box, Paper, Stack, Typography } from "@mui/material";

import {
  DEFAULT_VALUES,
  VALIDATION_SCHEMA,
} from "./delivery-customer-claim-form-constants";
import { DeliveryDetailSection } from "./delivery-detail-section";
import { ProductVariantsSection } from "./product-variants-section";
import { ReceiveClaimInformationSection } from "./receive-claim-information-section";

export const DeliveryCustomerClaimForm = ({
  defaultValues,
  onSubmit,
  renderActionButton,
  receiveClaimData,
}) => {
  const methods = useForm({
    defaultValues: {
      ...DEFAULT_VALUES,
      ...defaultValues,
    },
    resolver: yupResolver(VALIDATION_SCHEMA),
  });

  const { handleSubmit, formState, getValues } = methods;

  const handleFormSubmit = async (formData) => {
    const payload = {
      transactionDate: dayjs(formData.transactionDate).format("YYYY-MM-DD"),
      sellerId: formData.seller.id,
      buyerableId: formData.buyer.id,
      buyerableType: formData.buyerableType,
      warehouseId: formData.warehouse.id,
      note: formData.note || null,
      customerClaimProductVariants: formData.customerClaimProductVariants
        .filter((variant) => variant.selected) // Only include selected variants
        .map((variant) => ({
          customerClaimProductVariantId: variant.id, // Map id to customerClaimProductVariantId
          quantity: variant.quantity,
        })),
    };

    await onSubmit(payload);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
    }
  };

  console.log(getValues());
  

  console.log(formState.errors);

  return (
    <FormProvider {...methods}>
      <Stack
        component="form"
        noValidate
        onSubmit={handleSubmit(handleFormSubmit)}
        onKeyDown={handleKeyDown}
        spacing={2.5}
      >
        <ReceiveClaimInformationSection receiveClaimData={receiveClaimData} />

        <DeliveryDetailSection />

        <Paper sx={{ p: 2.5, borderRadius: 2 }}>
          <Stack spacing={2.5}>
            <Typography variant="h6">Barang yang Akan Dikirim</Typography>
            <ProductVariantsSection />
          </Stack>
        </Paper>

        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end"
          }}>
          {renderActionButton({ isSubmitting: formState.isSubmitting })}
        </Box>
      </Stack>
    </FormProvider>
  );
};

DeliveryCustomerClaimForm.propTypes = {
  defaultValues: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  renderActionButton: PropTypes.func.isRequired,
  receiveClaimData: PropTypes.object.isRequired,
};
